export default {
  // 頁面標題
  title: "餘額分析",

  // 表單相關
  chainPlaceholder: "請選擇主鏈",
  addressPlaceholder: "請輸入地址（最多不超過50條）",
  reset: "重置",
  query: "查詢",

  // 統計信息
  totalAccountBalance: "公鏈代幣總餘額：",
  totalUsdtBalance: "usdt代幣總餘額：",

  // 表格列標題
  serialNumber: "序號",
  blockchain: "公鏈",
  address: "地址",
  accountBalance: "公鏈代幣餘額(可用餘額)",
  usdtBalance: "USDT代幣餘額",
  updateTime: "更新時間",

  // 空數據
  noData: "暫無數據",

  // 下載相關
  downloadDetails: "下載數據明細",
  downloadFileName: "餘額數據",

  // Loading 文本
  loading: "拼命加載中",

  // 驗證和錯誤消息
  pleaseSelectChain: "請選擇鏈",
  pleaseEnterAddress: "請輸入地址",
  batchQueryLimit: "批量查詢最多可查詢50個以內的同一公鏈地址",

  // 新手引導
  guideStep1: "輸入地址查詢餘額，支持批量（50以內）地址餘額查詢",
};
